import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../../utils/removeKeys';

/**
* Row component for the flexbox grid layout.
* modifiers TBD - Flexbox properties added via CSS Modules.
*/
class Column extends React.Component {
  static displayName = 'Column';
  static propTypes = {
    /* Breakpoint to change flow and size of row/cols */
    breakPoint: PropTypes.oneOf([
      'large', 'medium', 'small'
    ]),
    /** Child Row/Column components to render */
    children: PropTypes.node,
    /** Modifiers for Flexbox - these are the align-items, justify-content and order style properties. */
    /** offset_x and push_x for margins in col_x widths% */
    modifiers: PropTypes.array,
    /** Column size for the container */
    size: PropTypes.number
  };
  static contextTypes = {
    grid: PropTypes.object
  };
  render() {
    const { classes, style, breakPoint, children, modifiers, size } = this.props;
    const { grid } = this.context;

    const colSize = size ? `col_${size}` : null;
    const resolvedStyleObject = {
      classes: classes || grid.classes,
      style: style || grid.style
    };
    const resolvedBreakPoint = breakPoint || grid.breakPoint;

    return (
      <div
        {...removeKeys(this.props, ['classes', 'style', 'breakPoint', 'children', 'modifiers', 'size'])}
        {...resolve(resolvedStyleObject, 'column', colSize, resolvedBreakPoint, ...modifiers)}>
        {children}
      </div>
    );
  }
}

export default Column;
